
import { Component, Vue } from 'vue-property-decorator';
import { FlagGroup, UserFlag } from '~/interfaces/user.interface';
import { RemoteFeatureFlagsModule } from '~/store/modules/remoteFeatureFlags';
import { UserModule } from '~/store/modules/user';

@Component({})
export default class CurrentUserGroups extends Vue {
    selectedGroup: string | null = null;

    async mounted() {
        if (!RemoteFeatureFlagsModule.availableFlags.length) {
            await RemoteFeatureFlagsModule.getAvailableFlags();
        }
        if (!RemoteFeatureFlagsModule.availableGroups.length) {
            await RemoteFeatureFlagsModule.getAvailableGroups();
        }
    }

    get currentUserGroups() {
        return RemoteFeatureFlagsModule.currentUserGroups;
    }

    groupFlags(group: FlagGroup): UserFlag[] {
        const groupFlagIds = group.flags.map((flag) => flag.id);
        return RemoteFeatureFlagsModule.availableFlags.filter((flag) => groupFlagIds.includes(flag.id));
    }

    async removeUserFromGroup(groupId: string) {
        try {
            await RemoteFeatureFlagsModule.removeUserFromGroup({
                group_id: groupId,
                user_id: UserModule.id,
            });
        } finally {
            await RemoteFeatureFlagsModule.getCurrentUserFlagIds();
        }
    }
}
